module.exports = __webpack_public_path__ + "media/30.1127ec27.mp3";